import { UtmCampaign } from '@mm/state/interfaces/lostLeadsReport';

const UtmKeys = {
  source: 'utm_source',
  medium: 'utm_medium',
  campaign: 'utm_campaign',
  campaignId: 'utm_content',
};

function postProcessText(val: string | null): string | null {
  if (val === null) return null;
  const trimmedVal = val.trim();
  return trimmedVal && trimmedVal !== '' ? trimmedVal : null;
}

function fetchUtmText(query: URLSearchParams, key: string): string | null {
  const val = query.get(key);
  return postProcessText(val);
}

function validId(val) {
  return !!val.match(/^[0-9a-f]+$/);
}

export function campaignParser(query: URLSearchParams): null | UtmCampaign {
  const campaignId = fetchUtmText(query, UtmKeys.campaignId);
  if (!campaignId || !validId(campaignId)) {
    return null;
  }
  const source = fetchUtmText(query, UtmKeys.source);
  const medium = fetchUtmText(query, UtmKeys.medium);
  const campaign = fetchUtmText(query, UtmKeys.campaign);

  const utmCampaign = {
    campaignId,
    source,
    medium,
    campaign,
  };

  // Remove empty values
  Object.keys(utmCampaign).forEach(key => {
    if (utmCampaign[key] === null || utmCampaign[key] === '') {
      delete utmCampaign[key];
    }
  });

  return utmCampaign as UtmCampaign;
}
